<template>
  <v-list two-line class="pb-0">
    <v-list-item-group>
      <template v-for="(item, index) in items">
        <v-list-item two-line v-if="index == 0" class="videoitem-content-th">
          <template class="vcard-list">
            <v-list-item-title style="width: 135px; flex: none">
              Status
            </v-list-item-title>
            <v-list-item-title style="text-align: left">
              Title
            </v-list-item-title>
            <v-list-item-title> &nbsp; </v-list-item-title>
          </template>
        </v-list-item>
        <v-list-item
          :key="item.title"
          two-line
          @click="loadVideo(item)"
          class="pt-0 pb-0"
        >
          <template class="videoitem-content-row">
            <v-row no-gutters>
              <v-list-item-icon class="videolisticon">
                <v-icon color="primary" class="" v-if="item.watched"
                  >fa fa-check-circle</v-icon
                >
                <v-icon v-else style="color: #212121"
                  >fa fa-arrow-circle-right</v-icon
                >
              </v-list-item-icon>
              <v-list-item-icon class="videolisticon ml-10">
                <v-icon>fa fa-film</v-icon>
              </v-list-item-icon>
              <v-list-item-content
                class="videolisticon ml-8"
                style="min-width: 132px"
              >
                <v-list-item-title
                  class="v-list-asset-title"
                  v-text="item.title"
                ></v-list-item-title>
                <v-list-item-subtitle class="text--primary">{{
                  item.description
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action
                v-if="!readOnly"
                class="list-icon-action"
                style="margin: 0px auto !important"
              >
                <v-btn
                  v-if="item.watched"
                  class="download-btn download-txt"
                  @click="playVideo(item)"
                >
                  <v-icon small class="pr-2">fa-redo</v-icon>Watch Again
                </v-btn>
                <v-btn
                  v-else
                  class="download-btn download-txt"
                  @click="playVideo(item)"
                >
                  <v-icon small class="pr-2">fa-play</v-icon>Play
                </v-btn>
              </v-list-item-action>
            </v-row>
          </template>
        </v-list-item>
        <!--<v-divider v-if="index + 1 < items.length" :key="index"></v-divider>-->
        <v-divider></v-divider>
      </template>
    </v-list-item-group>
  </v-list>
</template>
<script>
import TrainingMaterialListItem from '@/pages/authenticated/courses/TrainingMaterialListItem';

export default {
  name: 'TrainingMaterial',
  components: {
    TrainingMaterialListItem,
  },

  data: () => ({
    selected: false,
  }),
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items: function () {
      return this.$store.getters.videos;
    },
  },
  methods: {
    loadVideo(item) {
      this.$store.dispatch('setCurrentVideo', item);
    },
    playVideo(item) {
      this.$store.dispatch('setCurrentVideo', item).then(() => {
        this.$store.dispatch('setPlayVideo', true);
        this.$vuetify.goTo(200);
      });
    },
  },
};
</script>
<style>
.list-icon {
  margin: auto !important;
  vertical-align: middle;
}
</style>
